// Whose a persisted workout draft is (#288). The live slot and the
// quarantine slots live per phone and per backend, not per account: without
// a stamp, a second account signed in on the same phone was offered the
// first one's unsaved workout, and could save it as its own. The account is
// injected, never imported: this is shared code and knows nothing about the
// mobile auth module (the same seam as setLoggerDraftScope).
// ⚠️ Web injects nothing: its drafts carry no account and get no isolation
// between accounts on one browser (apps/web-rnw never calls the setter).

let source: () => string | null = () => null;
let injected = false;

/** Mobile, at boot: where the signed-in account is read from. */
export function setLoggerDraftOwner(fn: () => string | null): void {
  source = fn;
  injected = true;
}

/** The account a draft written now belongs to, or null. */
export const loggerDraftOwner = (): string | null => source();

/** True when the host stamps drafts (mobile): a null owner then means
 *  nobody is signed in, and nothing may be written. */
export const loggerDraftOwnerInjected = (): boolean => injected;

/** THE rule for a persisted draft: `owner` may see it when it is theirs,
 *  or from before the stamp (mobile's boot gives those to the first account
 *  signed in, apps/mobile state/draftOwnership.ts). The outbox's `isMine`
 *  stays apart on purpose: a queued row always has an owner, and an
 *  unowned row is nobody's there. */
export const isOwnDraft = (state: { owner?: string }, owner: string | null): boolean =>
  state.owner === undefined || state.owner === owner;

/** The owner a raw blob names, without validating the rest of it: a blob
 *  that no longer parses as a draft still belongs to someone. */
export function blobOwner(raw: string): string | undefined {
  try {
    const v: unknown = JSON.parse(raw);
    if (v === null || typeof v !== 'object') return undefined;
    const o = (v as { owner?: unknown }).owner;
    return typeof o === 'string' && o !== '' ? o : undefined;
  } catch {
    return undefined;
  }
}
